var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0312 0.796387C13.3047 1.06982 13.3047 1.47998 13.0312 1.72607L5.8125 8.94482C5.56641 9.21826 5.15625 9.21826 4.91016 8.94482L1.19141 5.22607C0.917969 4.97998 0.917969 4.56982 1.19141 4.29639C1.4375 4.05029 1.84766 4.05029 2.09375 4.29639L5.375 7.57764L12.1289 0.796387C12.375 0.550293 12.7852 0.550293 13.0312 0.796387Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8acbbb14fccff3db21aa1699b32b90c4.svg";
export { ForwardRef as ReactComponent };